import React from 'react';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

import {
  selectEarMarks,
  selectBrandImage,
  selectBrandPositions,
  selectImageRegisteredPositions,
} from 'selectors/brandRegistration';
import AnimalSelection from './AnimalSelection';
import StepActions from './StepActions';

const useStyles = makeStyles((theme) => ({
  legends: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  legend: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '10px 5px',
  },
  legendAvailable: {
    height: '15px',
    width: '15px',
    backgroundColor: theme.custom.white,
    marginRight: '5px',
    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
  },
  legendSelected: {
    height: '15px',
    width: '15px',
    backgroundColor: theme.custom.primary,
    marginRight: '5px',
  },
  legendRegistred: {
    height: '15px',
    width: '15px',
    backgroundColor: '#827f7f',
    marginRight: '5px',
  },
  legendDisabled: {
    height: '15px',
    width: '15px',
    backgroundColor: '#cccccc',
    marginRight: '5px',
  },
}));

const BrandPosition = () => {
  const { enqueueSnackbar } = useSnackbar();
  const earMarks = useSelector(selectEarMarks);
  const brandImage = useSelector(selectBrandImage);
  const brandPositions = useSelector(selectBrandPositions);
  const imageRegisteredPositions = useSelector(selectImageRegisteredPositions);
  const history = useHistory();
  const classes = useStyles();

  const handleNext = () => {
    const hasPosition = brandPositions.length > 0;

    if (hasPosition) {
      history.push('/brands/new/owners');
    } else {
      enqueueSnackbar(
        'Please select at least one brand position.',
        { variant: 'error' },
      );
    }
  };

  const handleBack = () => {
    history.push('/brands/new');
  };

  return (
    <React.Fragment>
      <StepActions handleNext={handleNext} handleBack={handleBack} />
      <div className={classes.legends}>
        <div className={classes.legend}>
          <span className={classes.legendAvailable}/> Available
        </div>
        <div className={classes.legend}>
          <span className={classes.legendSelected}/> Selected
        </div>
        <div className={classes.legend}>
          <span className={classes.legendRegistred} /> Registered
        </div>
        <div className={classes.legend}>
          <span className={classes.legendDisabled} /> N/A
        </div>
      </div>
      {brandImage && (
        <AnimalSelection
          brandPositions={brandPositions}
          imageRegisteredPositions={imageRegisteredPositions}
          brandImage={brandImage}
          earMarks={earMarks}
        />
      )}
      <StepActions handleNext={handleNext} handleBack={handleBack} />
    </React.Fragment>
  );
};

export default BrandPosition;
